import { isoStandard } from './isoStandard';
import { PixiBase } from '../core/pixi/PixiBase';
import { boostedJackpotDateHelper } from './gameDate';
import { userInfoStore } from '../store/userInfoStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';

let interval = null;

export function createTextWinAmountAndCurrencySymbol({
  x,
  y,
  name,
  margin,
  amount,
  fontSize = 16,
  color = '#FFC33E',
}) {
  const styles = {
    fill: color,
    align: 'center',
    fontWeight: 700,
    fontSize: fontSize,
    fontFamily: 'Arial',
  };
  const textsContainer = PixiBase.createContainer(name);
  textsContainer.name = name;
  PixiBase.setPosition(textsContainer, { x: x, y: y });
  const winAmountText = PixiBase.createText(amount ? isoStandard(amount) : '', styles);
  winAmountText.anchor.set(0.5);
  const currencySymbolText = PixiBase.createText(
    amount ? userInfoStore.currencySymbol : '',
    styles
  );
  currencySymbolText.anchor.set(0.5);
  currencySymbolText.x = winAmountText.width / 2 + margin;
  textsContainer.addChild(winAmountText, currencySymbolText);
  return textsContainer;
}

const handleDateTimeParts = ({ DD, HH, MM, SS, isIcon }) => {
  return [
    !isIcon || +DD ? DD : '',
    !isIcon || +HH || +DD ? HH : '',
    !isIcon || !+DD ? MM : '',
    !isIcon || (!+DD && !+HH) ? SS : '',
  ];
};

const handleBoostedIconDateShownPart = ({ DD, HH, MM, SS, container, titleContainer }) => {
  const showIndexes = +DD ? [0, 1] : +HH ? [1, 2] : [2, 3];
  container.children.forEach((el, index) => {
    const findIndex = showIndexes.findIndex((id) => id === index);
    if (findIndex > -1) {
      el.x = findIndex ? 25 : 0;
      titleContainer.children[index].x = el.x;
      titleContainer.children[index].visible = true;
      el.visible = true;
    } else {
      titleContainer.children[index].visible = false;
      el.visible = false;
    }
  });
  return { DD, HH, MM, SS };
};

const setAndUpdateBoostedJackPotDate = (container, titleContainer, isIcon) => {
  const { DD, HH, MM, SS, timeDiff } = boostedJackpotDateHelper();
  const dateTime = handleDateTimeParts({ DD, HH, MM, SS, isIcon });
  dateTime.forEach((dateTimePartText, index) => {
    container.children[index].text = dateTimePartText;
  });
  if (isIcon) {
    handleBoostedIconDateShownPart({ DD, HH, MM, SS, container, titleContainer });
  }
  if (timeDiff <= 0) {
    gameMainDrawer.boostedJackpot.BoostedJackpotIconContainer.visible = false;
    clearInterval(interval);
    interval = null;
  }
};

export const updateExpiresBoosted = (container, titleContainer, isIcon) => {
  interval = setInterval(() => {
    setAndUpdateBoostedJackPotDate(container, titleContainer, isIcon);
  }, 1000);
};
